import { Divider } from "@/components/misc";
import { useState, useEffect } from "react";
import { CardBase } from "./Utils/CardHelper";
import { NotesSection } from "../ProjectProgress/Utils/NotesSection";
import { TitleHeaderHyperlink } from "./Utils/TitleHeaderHyperlink";
import { BidProps } from "@/interfaces/bid_types";
import { CardDropdownBid } from "./Utils/CardDropdown";

type BidCardProps = {
    bid: BidProps,
    isNew: boolean,
    isMini: boolean,
    onView: () => void
}
export function BidCard({ bid, isNew, isMini, onView }: BidCardProps) {
    const [isNewLocal, setIsNewLocal] = useState(isNew);

    useEffect(() => {
        if (isNewLocal) {
            setIsNewLocal(true);
            onView();
        }
    }, [isNewLocal, onView]);

    return (
        <CardBase
            isNew={isNewLocal}
            hoverInsteadOfClick={isMini ? false : true}
            hoverChildren={<CardDropdownBid
                edit_bid_route={`/bids/update_bid/${bid.bid_id}`}
                folder_path={`${bid.folder_location}`} />}
        >
            {isMini ? <MiniBidCard bid={bid} /> : <DefaultBidCard bid={bid} />}
        </CardBase>
    );
}

function MiniBidCard({ bid }: { bid: BidProps }) {
    return (
        <TitleHeaderHyperlink title={bid.bid_name} folder_location={bid.folder_location ?? ''} />
    )
}

function DefaultBidCard({ bid }: { bid: BidProps }) {
    return (
        <>
            <TitleHeaderHyperlink title={bid.bid_name} folder_location={bid.folder_location ?? ''} />

            <Divider />

            <NotesSection notes={bid.description ?? ''} />

            <p className="text-right text-sm">{bid.end_date ? `Next Deadline: ${bid.end_date}` : 'No Date Due'}</p>

        </>
    )
}
